import { Button, makeStyles } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import saveEditLotInfo from '../../../api/Siteplan/saveEditLotInfo.api';
import styles from './EditLot.module.scss';
import ClearIcon from '@material-ui/icons/Clear';
import { useComponentVisible } from '../../../hooks/use-component-visible';
import Modal from '../../layout/modal/Modal';
const EditLot = ({ editLotInfo, closeModalHandler, handleHistory }) => {
	const { lotId, closingDate, premium, premiumDescription, source } =
		editLotInfo;
	const [showCalendar, setShowCalendar] = useState(false);
	const [newClosingDate, setNewClosingDate] = useState(new Date());
	const [formData, setFormData] = useState({
		premiumPrice: '',
		premiumDescription: '',
	});

	const { ref, isComponentVisible, setIsComponentVisible } =
		useComponentVisible(false);

	const useStyles = makeStyles(() => ({
		root: {
			minWidth: '30em',
			maxWidth: '30em',
			marginTop: '10px',
			marginBottom: '10px',
			backgroundColor: '#fff',
			position: 'relative',
		},

		calendarField: {
			position: 'relative',
			width: '100%',
		},
		clearIcon: {
			position: 'absolute',
			marginTop: '15px',
			right: '2px',
		},
	}));

	useEffect(() => {
		setFormData({
			premiumPrice: premium,
			premiumDescription: premiumDescription,
		});

		console.log('editLotInfoeditLotInfo', editLotInfo);
	}, [editLotInfo]);

	useEffect(() => {
		setNewClosingDate(closingDate);

		console.log('formData', formData);
	}, [editLotInfo]);

	useEffect(() => {
		console.log('newClosingDate', newClosingDate);
	}, [newClosingDate]);

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const classes = useStyles();

	const handleSaveEdit = (e) => {
		e.preventDefault();

		saveEditLotInfo(
			lotId,
			newClosingDate,
			formData.premiumPrice,
			formData.premiumDescription,
			source
		);

		closeModalHandler();
	};

	const clearCalendar = () => {
		console.log('clearCalendar');
		setNewClosingDate(null);
	};

	return (
		<div className={styles.edit_lot}>
			{editLotInfo && (
				<>
					<form
						onSubmit={handleSaveEdit}
						className={styles.edit_form}
						method='POST'
					>
						<TextField
							className={classes.root}
							label='Lot Id'
							value={lotId}
							variant='outlined'
							placeholder={lotId}
							disabled
						/>
						<div className={classes.root} ref={ref}>
							<TextField
								type='text'
								label='Closing Date'
								name='closingDate'
								variant='outlined'
								className={classes.calendarField}
								value={
									newClosingDate
										? newClosingDate
										: 'No Closing Date'
								}
								onClick={() => {
									setIsComponentVisible(true);
								}}
							/>
							<ClearIcon
								className={classes.clearIcon}
								onClick={clearCalendar}
							/>

							{isComponentVisible && (
								<>
									<div className='dates_wrapper'>
										<Calendar
											onChange={(e) => {
												setNewClosingDate(
													dayjs(
														new Date(e).getTime()
													).format('YYYY-MM-DD')
												);
												setShowCalendar(false);
											}}
											value={
												new Date(
													dayjs(
														newClosingDate
															? newClosingDate
															: new Date()
													)
												)
											}
											minDate={new Date()}
											className='new-react-calendar'
											showFixedNumberOfWeeks={true}
										/>
									</div>
								</>
							)}
						</div>
						<TextField
							className={classes.root}
							label='Premium Price'
							value={
								formData?.premiumPrice
									? formData.premiumPrice
									: ''
							}
							name='premiumPrice'
							variant='outlined'
							onChange={(e) => onChange(e)}
						/>
						<TextField
							className={classes.root}
							label='Premium Description'
							value={
								formData?.premiumDescription
									? formData.premiumDescription
									: ''
							}
							name='premiumDescription'
							variant='outlined'
							onChange={(e) => onChange(e)}
						/>

						<div className={styles.btn_group}>
							<Button
								variant='contained'
								type='submit'
								color='primary'
								className={styles.save_edit_btn}
							>
								Save Edit
							</Button>
							<Button
								variant='outlined'
								color='primary'
								className={styles.edit_history_btn}
								onClick={handleHistory}
							>
								View edit history
							</Button>
						</div>
					</form>
				</>
			)}
		</div>
	);
};

export default EditLot;
